import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@form-validation/core/lib/styles/index.css'
import '@form-validation/plugin-bootstrap5/lib/styles/index.css'
import './styles/app.scss'

const root = document.getElementById('root')
if (!root) {
  throw new Error('Root element was not found')
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
